/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What data does a Venn diagram need?`)
};

const es_venn_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué datos necesita un diagrama de Venn?`)
};

const de_venn_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Daten benötigt ein Venn-Diagramm?`)
};

const nl_venn_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke gegevens heeft een Venn-diagram nodig?`)
};

const fr_venn_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De quelles données un diagramme de Venn a-t-il besoin ?`)
};

const it_venn_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di quali dati ha bisogno un diagramma di Venn?`)
};

const pt_br2_venn_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De que dados um diagrama de Venn precisa?`)
};

const pt_venn_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados são necessários para um diagrama de Venn?`)
};

const ja_venn_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベン図にはどのようなデータが必要ですか?`)
};

const zh_venn_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`维恩图需要什么样的数据？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_faq_q1", locale)
	if (locale === "en") return en_venn_faq_q1(inputs)
	if (locale === "es") return es_venn_faq_q1(inputs)
	if (locale === "de") return de_venn_faq_q1(inputs)
	if (locale === "nl") return nl_venn_faq_q1(inputs)
	if (locale === "fr") return fr_venn_faq_q1(inputs)
	if (locale === "it") return it_venn_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_venn_faq_q1(inputs)
	if (locale === "pt") return pt_venn_faq_q1(inputs)
	if (locale === "ja") return ja_venn_faq_q1(inputs)
	return zh_venn_faq_q1(inputs)
};